<template>
    <div id="datenschutz">
        <div class="legal">
            <h2>
                Datenschutzerklärung
            </h2>

            <div ref="decaretoContainer"></div>

            <p>
                Zurück zur
            </p>
            <p>
                <router-link
                    class="button button-red"
                    :to="{ name: 'start' }"
                >
                    Startseite
                </router-link>
            </p>
        </div>
    </div>
</template>

<script>

export default {

    components : {},

    beforeDestroy(){
        this.removeDecareto();
    },
    created(){
    },
    destroyed(){
    },
    mounted(){
        window.console.log('Datenschutz mounted');
        this.updateMetaTags();
        this.embedDecareto();
    },
    updated(){
    },

    computed : {},

    data(){
        return {
            metaTags : {
                'meta[name="description"]' : '',
                'meta[property="og:description"]' : '',
                'meta[property="og:title"]' : '',
                'meta[property="og:url"]' : 'http://www.med-in-mind.de/datenschutz',
            },
        };
    },

    methods : {
        embedDecareto(){
            window.console.log('embedDecareto');
            const div = document.createElement('div');
            div.id = 'dcrt_dps_content';
            this.$refs.decaretoContainer.appendChild(div);
            const script = document.createElement('script');
            script.text = `fetch("https://decareto.b-cdn.net/p/dde0f24215b8a0ccfab9.js", { cache : "no-store" }).then(response=>response.text()).then(data=>{ eval(data); });`;
            this.$refs.decaretoContainer.appendChild(script);
        },
        removeDecareto(){
            window.console.log('removeDecareto');
            const divs = this.$refs.decaretoContainer.querySelectorAll('div');
            divs.forEach(div=>div.remove());
            const scripts = this.$refs.decaretoContainer.querySelectorAll('script');
            scripts.forEach(script=>script.remove());
        },
        updateMetaTags(){
            window.console.log('updateMetaTags', this.$route.path, this.metaTags);
            if (this.metaTags) {
                for (let [key, value] of Object.entries(this.metaTags)) {
                    document.querySelector(key).setAttribute('content', value);
                }
            }
        },
    },

    props : [],

    watch : {},

}

</script>

<style lang="scss">

@import "../assets/css/variables";

#datenschutz {
    padding: 96px 120px 48px 72px;
    overflow: hidden;
    @media screen and (max-width: 767px) {
        padding: 80px 32px 32px 32px;
    }
    @media screen and (max-height: 511px) {
        padding: 72px 16px 16px 16px;
    }
}

.legal {
    #dcrt_dps_content{
        h2 {
            margin: 16px 0;
            font-family: $font-family-avenir-black;
            font-size: 16px;
            font-weight: normal;
            @media screen and (max-width: 767px), screen and (max-height: 511px) {
                font-size: 14px;
            }
        }
        h3 {
            margin: 16px 0;
            font-family: $font-family-avenir-black;
            font-size: 16px;
            font-weight: normal;
            @media screen and (max-width: 767px), screen and (max-height: 511px) {
                font-size: 14px;
            }
        }
    }
    a {
        color: $color-medinmind-red;
    }
    p {
        @media screen and (max-width: 767px), screen and (max-height: 511px) {
            font-size: 14px;
        }
    }
    h2 {
        margin: 0 0 24px 0;
        font-family: $font-family-avenir-medium;
        font-size: 48px;
        font-weight: normal;
        @media screen and (max-width: 767px), screen and (max-height: 511px) {
            font-size: 24px;
        }
    }
    h4 {
        margin: 16px 0;
        font-family: $font-family-avenir-black;
        font-size: 16px;
        font-weight: normal;
        @media screen and (max-width: 767px), screen and (max-height: 511px) {
            font-size: 14px;
        }
    }
    h5 {
        margin: 16px 0;
        font-family: $font-family-avenir-black;
        font-size: 16px;
        font-weight: normal;
        @media screen and (max-width: 767px), screen and (max-height: 511px) {
            font-size: 14px;
        }
    }
    ol, ul {
        margin-top: 16px;
        margin-bottom: 16px;
        @media screen and (max-width: 767px), screen and (max-height: 511px) {
            padding-inline-start: 16px;
        }
        li {
            margin-top: 16px;
            margin-bottom: 16px;
            font-size: 16px;
            @media screen and (max-width: 767px), screen and (max-height: 511px) {
                font-size: 14px;
            }
            &:first-child {
                margin-top: 0;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    > ol, ul {
        > li {
            ol, ul {
                li {
                    margin-top: 0;
                    margin-bottom: 0;
                }
            }
        }
    }
}

</style>
